import { isRequired as isRequiredCU, isEmail as isEmailCU, isNumber as isNumberCU, isPhoneNumber as isPhoneNumberCU } from '@unite-us/client-utils/dist/utils/validations/validations';
import { validateDate as validateDateUI } from '@unite-us/ui/dist/utils/Dates';
export function isRequired(value) {
  return isRequiredCU(value);
}
export function isEmail(value) {
  return isEmailCU(value);
}
export function isNumber(value) {
  return isNumberCU(value);
}
export function isPhoneNumber(value) {
  return isPhoneNumberCU(value);
}
export function validateDate(date, maxDate, minDate) {
  return validateDateUI(date, maxDate, minDate, false, 'MM/DD/YYYY');
}
//# sourceMappingURL=validations.js.map